import {
  Component,
  DestroyRef,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {AsyncPipe} from '@angular/common';
import {toSignal} from '@angular/core/rxjs-interop';
import {
  firstValueFrom,
  map,
} from 'rxjs';
import {AppState} from '../../store/store';
import {selectNavigationData} from '../../store/portal/portal.selectors';
import {NavCardComponent} from '../nav-card/nav-card.component';
import {ContentPages} from '../../enums/content-page';
import {selectIsPreviewMode} from '../../store/shared-link/shared-link.selectors';
import {PreviewModeService} from '../../services/preview-mode/preview-mode.service';

@Component({
  selector: 'app-content-sections',
  imports: [NavCardComponent, TranslatePipe, AsyncPipe],
  templateUrl: './content-sections.component.html',
  styleUrl: './content-sections.component.scss',
})
export class ContentSectionsComponent {

  private readonly store: Store<AppState> = inject(Store<AppState>);

  private readonly router: Router = inject(Router);

  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  private readonly previewModeService: PreviewModeService = inject(PreviewModeService);

  public readonly lg: InputSignal<boolean> = input<boolean>(false);

  private destroyRef: DestroyRef = inject(DestroyRef);

  readonly ContentPages = ContentPages;

  public navigationState$ = this.store.select(selectNavigationData);

  public previewMode$ = this.store.select(selectIsPreviewMode);

  public activePage = toSignal(
    this.activatedRoute.url.pipe(map(segments => segments[segments.length - 1]?.path || '')),
    {initialValue: ''},
  );

  async goTo(page: ContentPages): Promise<void> {
    const previewMode = await firstValueFrom(this.previewMode$);
    if (this.destroyRef.destroyed) {
      return;
    }
    if (previewMode) {
      await this.previewModeService.toPreview(page);
    } else {
      const username = this.activatedRoute?.snapshot.paramMap.get('username');
      if (username) {
        await this.router.navigate([username, page]);
      }
    }
  }

}
